import { useMutation } from "@tanstack/react-query";
import { axiosInvoiceLess } from "../libs/axios";

interface ICutsomer{
  billTo : {
    company?: string;
    email: string;
    phone?: string;
    address?: string;
    firstName?: string;
    lastName?: string;
  }
}
interface ICutsomerResponse{
  id: string;
  email: string;
}
const normolize = (req: ICutsomerResponse) => {
  return req as ICutsomerResponse
}

const createCustomer = async (params: ICutsomer) =>{
  try{
    const res  =(await axiosInvoiceLess.post('/customers', params)).data;
    return normolize(res)
  }catch(error){
    console.log('Error create customer', error);
  }
}

export const useCreateCustomer = () => {
  return useMutation({
    mutationKey: ['create-customers'],
    mutationFn: createCustomer,
  });
};